module.exports = __webpack_public_path__ + "assets/img/20_310.83b46dc6.jpg";